import { render, staticRenderFns } from "./Osechi.vue?vue&type=template&id=78c780d8&scoped=true"
import script from "./Osechi.vue?vue&type=script&lang=js"
export * from "./Osechi.vue?vue&type=script&lang=js"
import style0 from "./Osechi.vue?vue&type=style&index=0&id=78c780d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c780d8",
  null
  
)

export default component.exports